import { ArrowBack } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';
import React, { ReactNode } from 'react';

import WsColors from '../../WsColors';
import { WsTypography, WsTypoColors, WsTypoVariants } from '../WsTypography';

export type WsTitleBannerPropsType = {
  title: string;
  leftChildren?: ReactNode | null;
  rightChildren?: ReactNode | null;
  goBack?: () => void;
  backButton?: boolean;
  showBetaIcon?: boolean;
};

const WsTitleBanner = ({
  title,
  leftChildren = null,
  rightChildren = null,
  goBack,
  backButton = true,
  showBetaIcon,
}: WsTitleBannerPropsType) => (
  <Box bgcolor={WsColors.TheBlues900} borderRadius={1.5} p={4}>
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={2} alignItems="center">
        {backButton && (
          <ArrowBack cursor="pointer" sx={{ color: WsColors.White }} onClick={goBack} />
        )}
        <WsTypography
          color={WsTypoColors.WHITE}
          variant={WsTypoVariants.TITLE}
          cursor="pointer"
          bold
        >
          {title}
        </WsTypography>
        {showBetaIcon && (
          <Button
            sx={{
              borderRadius: 50,
              borderColor: WsColors.TheBlues500,
              borderWidth: '2px',
              fontWeight: 'bold',
            }}
            variant="outlined"
            size="small"
          >
            Beta
          </Button>
        )}
      </Stack>
      {rightChildren}
    </Stack>
    <Stack pl={5}>{leftChildren}</Stack>
  </Box>
);

export default WsTitleBanner;
